<template>
  <div class="payroll-settings">

      <h1 class="text-left mx-4 my-2">Payroll Settings</h1>
      <v-row no-gutters>
        <v-col cols="12" md="3">
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'PayrollParticulars' }">
            <h2 class="text--secondary text-left font-weight-medium">Payroll Particulars</h2>
          </v-card>
        </v-col>  
        <v-col cols="12" md="3">
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'AllPayrollGroups' }">
            <h2 class="text--secondary text-left font-weight-medium">Payroll <br> Groups</h2>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <!-- Payslip settings router link -->
          <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: 'PayslipSettings' }">
            <h2 class="text--secondary text-left font-weight-medium">Payslip Settings</h2>
          </v-card>
        </v-col>  
      </v-row>
  </div>
</template>

<script>
export default {
  name: "PayrollSettings",
  computed: {
  },
  data() {
    return {
      
    };
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>